export default "__VITE_ASSET__CIdQ1vsU__"